import Drawer from "../../../.shared/Drawer/Drawer";
import IconClose from "app/pages/.shared/IconClose";
import { Fragment, memo, useCallback, useRef, useState } from "react";
import { useField } from "formik";
import classNames from "classnames";
import PropTypes from "prop-types";
import { messagePropType } from "app/utils/propTypes";
import AdvancedSelectFormik from "app/pages/.shared/form/AdvancedSelectFormik/AdvancedSelectFormik";
import "./SmartDPInputSidePanelContent.scss";
import { isEmpty } from "lodash";
import useVisualViewport from "app/utils/hooks/useVisualViewport";
import useHidePartnerCustomHeader from "app/utils/hooks/useHidePartnerCustomHeader";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import useBlockScroll from "app/utils/hooks/useBlockScroll";

const SmartDPInputSidePanelContent = props => {
	const [isOpen, setOpen] = useState(false);
	const {
		id,
		label,
		className,
		isRequired,
		drawerInputLabel,
		drawerTitleLabel,
		getOptionLabel = () => {},
		isSearchable = true,
		openMenuOnFocus,
	} = props;
	const [field, meta, helpers] = useField(props);
	const { setError } = helpers;
	const selectRef = useRef();
	const [viewports, hasKeyboard] = useVisualViewport();
	useBlockScroll({ isModalOpen: isOpen && hasKeyboard });
	useHidePartnerCustomHeader({ hide: isOpen });

	const isTouched = field.value;

	const inputClassName = classNames("smartdp-input-search-select", className, {
		"smartdp-input-search-select--required": isRequired,
		"smartdp-input-search-select--touched": isTouched,
		"smartdp-input-search-select--error": meta.touched && meta.error,
	});

	const handleInputValueChange = useCallback(option => {
		helpers.setValue(option);
		helpers.setTouched(true);
		if (!isEmpty(option)) {
			handleClose();
		}
	}, []);

	const handleClose = useCallback(() => {
		setTimeout(() => {
			setOpen(false);
		}, [300]);
	}, []);

	const handleOpen = useCallback(() => {
		setOpen(true);
		setError();
	}, []);

	return (
		<Fragment>
			<div className={inputClassName} onClick={handleOpen}>
				<label htmlFor={id} className="smartdp-input-search-select__label">
					{isTouched ? (
						<Typography variant={TYPOGRAPHY_VARIANTS.XSMALL} isBold>
							{label}
						</Typography>
					) : (
						<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR}>{label}</Typography>
					)}
				</label>
				{field.value && (
					<div className="smartdp-input-search-select__input">
						{getOptionLabel(field.value)}
					</div>
				)}
			</div>
			<Drawer
				isOpen={isOpen}
				direction={"rtl"}
				sidePanelClassName="smartDP-input-side-panel"
				drawerClassName="smartDP-input-side-panel__content"
				style={{ height: viewports?.visualViewport?.height }}
			>
				<div className="advanced-select__container">
					<div className="advanced-select__header">
						<Typography variant={TYPOGRAPHY_VARIANTS.XL} isBold component="div">
							{drawerTitleLabel ? drawerTitleLabel : label}
						</Typography>
						<div className="advanced-select__header-icon">
							<IconClose width={24} height={24} onClick={handleClose} />
						</div>
					</div>
				</div>
				<AdvancedSelectFormik
					menuIsOpen={openMenuOnFocus}
					{...props}
					label={drawerInputLabel ? drawerInputLabel : label}
					autoFocus={isSearchable}
					isClearable={isSearchable}
					selectRef={selectRef}
					classNamePrefix="advanced-select__select-sdp"
					onChange={handleInputValueChange}
					captureMenuScroll={false}
					menuShouldBlockScroll={hasKeyboard}
					menuPortalTarget={null} // mode portal par défaut, on force à null pour éviter pb affichage sur mobile quand le side panel s'ouvre
				/>
			</Drawer>
		</Fragment>
	);
};

SmartDPInputSidePanelContent.propTypes = {
	id: PropTypes.string,
	label: messagePropType,
	value: PropTypes.any,
	isSearchable: PropTypes.bool,
	getOptionLabel: PropTypes.func,
	isRequired: PropTypes.bool,
	openMenuOnFocus: PropTypes.bool,
	drawerInputLabel: messagePropType,
	drawerTitleLabel: messagePropType,
};

export default memo(SmartDPInputSidePanelContent);
